import { useEffect, useState } from 'react'
import styles from './EditCompanyCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import CompanyCardCategories from '../../components/CompanyCardCategories/CompanyCardCategories'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import EditCompanyCardMainInformation from '../../components/EditCompanyCardMainInformation/EditCompanyCardMainInformation'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import { useNavigate, useParams } from 'react-router-dom'
import { blockCompany, deleteCompany, getCurrentCompany } from '../../redux/actions/companiesAction'
import Loader from '../../components/UI/Loader/Loader'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import PATH from '../../navigation/path'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useMediaQuery } from 'react-responsive'
import { useToast } from '../../context/ToastContext'

const EditCompanyCardPage = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const { showSuccess, showError } = useToast()
  const { companyId } = useParams<{ companyId: string }>()
  const { token, user, userRole } = useAppSelector((state) => state.auth)

  const { currentCompany, isLoading } = useAppSelector((state) => state.companies)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const onChangeSwipeCheckboxHandler = async (checked: boolean) => {
    await dispatch(
      blockCompany({
        token,
        companyId: String(currentCompany.id),
        isBlocked: !checked,
      }),
    )

    await dispatch(getCurrentCompany({ companyId, token }))
  }

  const onDeletePlatformHandler = () => {
    setVisible(true)
  }

  const onDeleteCompany = async () => {
    const resultAction = await dispatch(deleteCompany({ companyId, token }))

    if (deleteCompany.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении компании')
    } else {
      navigate(PATH.companyManagementPage)
      showSuccess('Компания успешно удалена')
    }
  }

  const foundObject = currentCompany.employees.find((item) => item.id === user.employee?.id)

  useEffect(() => {
    dispatch(getCurrentCompany({ companyId, token }))
  }, [])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.editCompanyCardPage}>
      <CustomModal visible={visible} setVisible={setVisible}>
        <DeleteComponent
          title='Удаление компании'
          description='Хотите удалить данную компанию ?'
          onCancelHandler={() => setVisible(false)}
          onDeleteHandler={onDeleteCompany}
        />
      </CustomModal>
      <Navbar />
      <HeaderForCard
        deleteButton={
          <CustomButton
            iconSrc={IconTrashRed}
            className={styles.deleteBtn}
            title={isMobile ? '' : 'Удалить компанию'}
            onClick={onDeletePlatformHandler}
          />
        }
        title='Карточка компании'
      />
      <CompanyCardCategories
        categories={
          userRole === 'superAdmin' ||
          userRole === 'admin' ||
          userRole === 'directorPlace' ||
          (userRole === 'employeePlace' && foundObject) ||
          userRole === 'directorAgent'
            ? [
                { id: 1, title: 'Основная информация' },
                { id: 2, title: 'Сотрудники компании' },
                { id: 3, title: 'Залы компании' },
              ]
            : [
                { id: 1, title: 'Основная информация' },
                { id: 3, title: 'Залы компании' },
              ]
        }
        activeLink={1}
        cardId={companyId}
      />

      <div className={styles.content}>
        <EditCompanyCardMainInformation companyData={currentCompany} />
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default EditCompanyCardPage
